module.exports = __webpack_public_path__ + "img/logo-icon.18869b61.png";